import { CheckboxComponent } from './checkbox';

export const Checkbox = CheckboxComponent;
